import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@t90/ui';
import { Calendar } from 'lucide-react';

export function SchedulePage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Schedule</h1>
        <p className="text-muted-foreground">
          View your work schedule and upcoming events
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Calendar className="h-5 w-5" />
            Work Schedule
          </CardTitle>
          <CardDescription>
            Your assigned work schedule
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground text-center py-12">
            Schedule information will be displayed here.
            Contact your team lead for current schedule details.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
